'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
class BlockLastTestimonies extends _react.Component {
  state = {
    loading: false
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchTestimonies();
  }
  fetchTestimonies = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/testimony/get-all').then(function (xhr, response) {
      component.setState({
        loading: false,
        testimonies: response.testimonies
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || error);
      component.setState({
        loading: false,
        info: undefined,
        error: response?.error,
        warning: response?.warning
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    if (!state.testimonies) return null;
    const slider_settings = {
      dots: false,
      infinite: true,
      speed: 1500,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      autoplay: true,
      autoplaySpeed: 15000,
      useCSS: true,
      breakpoint: 100,
      arrows: true,
      adaptiveHeight: true
    };
    const testimonies = (state.testimonies || []).filter(testimony => testimony.type === props.type).map(function (testimony) {
      let output = /*#__PURE__*/_react.default.createElement("div", {
        className: "c-item__slide c-item__slide--testimony",
        key: testimony.id
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-testimony"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-testimony__txt",
        dangerouslySetInnerHTML: {
          __html: testimony.comment
        }
      }), testimony.author ? /*#__PURE__*/_react.default.createElement("div", {
        className: "c-testimony__author"
      }, testimony.author) : undefined));
      return output;
    });
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: "c-testimonies"
    }, /*#__PURE__*/_react.default.createElement(_reactSlick.default, _extends({
      className: "u-full-width testimonies-slider"
    }, slider_settings), testimonies));
    return output;
  }
}
exports.default = BlockLastTestimonies;
